// Generate MongoDB-style ObjectId without BSON dependency
export function newId() {
  // Generate a 24-character hex string (12 bytes)
  const timestamp = Math.floor(Date.now() / 1000).toString(16);
  const randomBytes = Array.from({length: 16}, () => Math.floor(Math.random() * 16).toString(16)).join('');
  return (timestamp + randomBytes).substring(0, 24);
}